import { render } from "./AppTable.vue?vue&type=template&id=6a5b3e7e"
import script from "./AppTable.vue?vue&type=script&lang=js"
export * from "./AppTable.vue?vue&type=script&lang=js"
script.render = render

export default script